import {createMediaSignals} from '@pexip/media';
import {createSignal} from '@pexip/signal';

export const pushToTalkSignal = createSignal<boolean>({
    name: 'media:unmute:actions',
});

export const mediaSignals = createMediaSignals(
    [
        'onAddTrack',
        'onDevicesChanged',
        'onMediaTrackMuted',
        'onMediaTrackResumed',
        'onMediaTrackStopped',
        'onMediaTrackSuspended',
        'onRemoveTrack',
        'onStatusChanged',
        'onUpdatingAudio',
        'onUpdatingVideo',
    ],
    'infinity-connect-main',
);
